import React, { useState, useEffect } from "react";
import { db, auth, googleProvider } from "./../../firebase";
import {
  collection, doc, getDoc, getDocs, setDoc, addDoc, updateDoc, query, where
} from "firebase/firestore";
import { signInWithEmailAndPassword, signInWithPopup, signOut } from "firebase/auth";
import ExperiencesAdminSection from "../../components/Admin/ExperiencesAdminSection";
import ProjectsAdminSection from "../../components/Admin/ProjectsAdminSection";
import SkillsAdminSection from "../../components/Admin/SkillsAdminSection";
import AboutPageAdminSection from "../../components/Admin/AboutPageAdminSection";
import PersonalInfoAdminSection from "../../components/Admin/PersonalInfoAdminSection";
import HeroProfileAdminSection from "../../components/Admin/HeroProfileAdminSection";
import ContactInfoAdminSection from "../../components/Admin/ContactInfoAdminSection";
import FooterAdminSection from "../../components/Admin/FooterAdminSection";

const LANGS = [
  { code: "en", label: "English" },
  { code: "es", label: "Español" }
];

const ADMIN_EMAIL = "jorge.luis.casagrande@gmail.com";

export default function AdminPage() {
  const [user, setUser] = useState(null);
  const [login, setLogin] = useState({ email: "", password: "" });
  const [lang, setLang] = useState("en");

  // States for each section
  const [aboutPage, setAboutPage] = useState(null);
  const [footerContent, setFooterContent] = useState(null);
  const [skills, setSkills] = useState([]);
  const [experiences, setExperiences] = useState([]);
  const [projects, setProjects] = useState([]);
  const [heroProfile, setHeroProfile] = useState(null);
  const [contactInfo, setContactInfo] = useState(null);
  const [personalInfo, setPersonalInfo] = useState(null);

  // Auth
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      if (user && user.email !== ADMIN_EMAIL) {
        alert("No tienes permisos para acceder.");
        signOut(auth);
        setUser(null);
      } else {
        setUser(user);
      }
    });
    return unsubscribe;
  }, []);

  // Fetch all data for selected lang
  useEffect(() => {
    if (!user) return;

    getDoc(doc(db, "aboutPage", lang)).then(snap => setAboutPage(snap.data()));
    getDoc(doc(db, "footerContent", lang)).then(snap => setFooterContent(snap.data()));
    getDocs(query(collection(db, "skills"), where("lang", "==", lang))).then(snapshot =>
      setSkills(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })))
    );
    getDocs(query(collection(db, "experiences"), where("lang", "==", lang))).then(snapshot =>
      setExperiences(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })))
    );
    getDocs(query(collection(db, "projects"), where("lang", "==", lang))).then(snapshot => {
      const projectsDocs = snapshot.docs.map(doc => ({
                      id: doc.id, // <-- este es el ID de Firestore
                      ...doc.data()
      }));
      
      setProjects(projectsDocs);
    }      
    );
    getDoc(doc(db, "heroProfile", lang)).then(snap => setHeroProfile(snap.data()));
    getDoc(doc(db, "contactInfo", lang)).then(snap => setContactInfo(snap.data()));
    getDoc(doc(db, "personalInfo", lang)).then(snap => setPersonalInfo(snap.data()));
  }, [lang, user]);

  // Auth handlers
  const handleLogin = async e => {
    e.preventDefault();
    await signInWithEmailAndPassword(auth, login.email, login.password);
  };
  const handleGoogleLogin = async () => {
    await signInWithPopup(auth, googleProvider);
  };
  const handleLogout = () => signOut(auth);

  // Update AboutPage
  // const handleAboutPageChange = e => setAboutPage({ ...aboutPage, [e.target.name]: e.target.value });
  const saveAboutPage = async () => {
    await setDoc(doc(db, "aboutPage", lang), aboutPage);
    alert("AboutPage saved!");
  };

  // Update FooterContent
  const handleFooterChange = e => setFooterContent({ ...footerContent, [e.target.name]: e.target.value });
  const saveFooterContent = async () => {
    await setDoc(doc(db, "footerContent", lang), footerContent);
    alert("Footer saved!");
  };

  // Guardar heroProfile
  const saveHeroProfile = async () => {
    await setDoc(doc(db, "heroProfile", lang), heroProfile);
    alert("Hero Profile guardado!");
  };

  // Guardar contactInfo
  const saveContactInfo = async () => {
    await setDoc(doc(db, "contactInfo", lang), contactInfo);
    alert("Contact Info guardado!");
  };

  // Guardar personalInfo
  const savePersonalInfo = async () => {
    await setDoc(doc(db, "personalInfo", lang), personalInfo);
    alert("Personal Info guardado!");
  };

  // CRUD for skills, experiences, projects
  const [skillInput, setSkillInput] = useState("");

  const [editingSkillId, setEditingSkillId] = useState(null);
  const [editingSkillValue, setEditingSkillValue] = useState("");

  const [editingProjId, setEditingProjId] = useState(null);
  const [editingProj, setEditingProj] = useState({});

  // Estado para el modal
  const [showExpModal, setShowExpModal] = useState(false);
  const [techDraft, setTechDraft] = useState({ name: "", icon: "" });
  const [modalExp, setModalExp] = useState({ title: "", description: "", skills: [], image: "" }); // skills como array
  const [editingExpId, setEditingExpId] = useState(null);

  // Abrir modal para agregar
  const openAddExpModal = () => {
    setModalExp({ title: "", description: "", skills: [], image: "" }); // skills como array
    setEditingExpId(null);
    setShowExpModal(true);
  };

  // Abrir modal para editar
  const openEditExpModal = (exp) => {
    setModalExp(exp);
    setEditingExpId(exp.id);
    setShowExpModal(true);
  };

  const handleAddTech = () => {
  if (!techDraft.name) return;
  setModalExp({
    ...modalExp,
    skills: [...(Array.isArray(modalExp.skills) ? modalExp.skills : []), { ...techDraft }]
  });
  setTechDraft({ name: "", icon: "" });
};

const handleDeleteTech = idx => {
  setModalExp({
    ...modalExp,
    skills: modalExp.skills.filter((_, i) => i !== idx)
  });
};

  // Guardar experiencia (agregar o editar)
  const saveExpModal = async () => {
    if (!modalExp.title) return;
    if (editingExpId) {
      await updateDoc(doc(db, "experiences", editingExpId), modalExp);
    } else {
      await addDoc(collection(db, "experiences"), modalExp);
    }
    setShowExpModal(false);
    setEditingExpId(null);
    // Refrescar lista
    getDocs(query(collection(db, "experiences"), where("lang", "==", lang))).then(snapshot =>
      setExperiences(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })))
    );
  };

  const [projForm, setProjForm] = useState({
    title: "",
    description: "",
    skills: "",
    image: ""
  });

  if (!user) {
    return (
      <div className="adminContainer">
        <div className="adminPanel adminPanelLogin">
          <h2 className="adminTitle" style={{ marginBottom: "1.5rem", color: "#222" }}>Admin Login</h2>
          <form onSubmit={handleLogin} style={{ width: "100%" }}>
            <input
              type="email"
              placeholder="Email"
              value={login.email}
              onChange={e => setLogin({ ...login, email: e.target.value })}
              required
              className="input"
              style={{ marginBottom: "1rem" }}
            />
            <input
              type="password"
              placeholder="Password"
              value={login.password}
              onChange={e => setLogin({ ...login, password: e.target.value })}
              required
              className="input"
              style={{ marginBottom: "1.2rem" }}
            />
            <button type="submit" className="button" style={{ width: "100%", marginBottom: "1rem" }}>
              Iniciar sesión
            </button>
          </form>
          <div style={{ width: "100%", textAlign: "center", margin: "0.5rem 0", color: "#888" }}>
            o
          </div>
          <button
            onClick={handleGoogleLogin}
            className="input"
            style={{
              width: "100%",
              background: "#fff",
              color: "#222",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "0.5rem"
            }}
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/4/4a/Logo_2013_Google.png"
              alt="Google"
              style={{ width: "20px", height: "20px" }}
            />
            Iniciar sesión con Google
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="adminContainer">
      <div className="adminPanel">
        <div className="adminHeader">
          <h1 className="adminTitle">Admin Panel</h1>
          <button className="logoutBtn" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div style={{ margin: "2rem 0 1.5rem 0", display: "flex", alignItems: "center", gap: "1rem" }}>
          <label className="label">Idioma:</label>
          <select
            value={lang}
            onChange={e => setLang(e.target.value)}
            className="input"
            style={{ width: 150 }}
          >
            {LANGS.map(l => (
              <option key={l.code} value={l.code}>{l.label}</option>
            ))}
          </select>
        </div>

        {/* === HERO PROFILE === */}
        <HeroProfileAdminSection
          lang={lang}
          heroProfile={heroProfile}
          setHeroProfile={setHeroProfile}
          saveHeroProfile={saveHeroProfile}
        />

        {/* === ABOUT PAGE (Hero y Interesting Facts) === */}
          <AboutPageAdminSection
            lang={lang}
            aboutPage={aboutPage}
            setAboutPage={setAboutPage}
            saveAboutPage={saveAboutPage}
          />

          {/* === PERSONAL INFO === */}
          <PersonalInfoAdminSection
            lang={lang}
            personalInfo={personalInfo}
            setPersonalInfo={setPersonalInfo}
            savePersonalInfo={savePersonalInfo}
          /> 

        {/* === SKILLS === */}
          <SkillsAdminSection
            lang={lang}
            skills={skills}
            setSkills={setSkills}
            skillInput={skillInput}
            setSkillInput={setSkillInput}
            editingSkillId={editingSkillId}
            setEditingSkillId={setEditingSkillId}
            editingSkillValue={editingSkillValue}
            setEditingSkillValue={setEditingSkillValue}
          />

        {/* === EXPERIENCES === */}
          <ExperiencesAdminSection
            lang={lang}
            experiences={experiences}
            openAddExpModal={openAddExpModal}
            openEditExpModal={openEditExpModal}
            setExperiences={setExperiences}
          />

        {/* === PROJECTS === */}
          <ProjectsAdminSection
            lang={lang}
            projects={projects}
            setProjects={setProjects}
            projForm={projForm}
            setProjForm={setProjForm}
            editingProjId={editingProjId}
            setEditingProjId={setEditingProjId}
            editingProj={editingProj}
            setEditingProj={setEditingProj}
          />

        {/* === FOOTER === */}
        <FooterAdminSection
          lang={lang}
          footerContent={footerContent}
          handleFooterChange={handleFooterChange}
          saveFooterContent={saveFooterContent}
        />

        {/* === CONTACT INFO === */}
        <ContactInfoAdminSection
          lang={lang}
          contactInfo={contactInfo}
          setContactInfo={setContactInfo}
          saveContactInfo={saveContactInfo}
        />

        {/* === MODAL (Experiences) === */}
        {showExpModal && (
          <div style={{
            position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
            background: "#0008", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000
          }}>
            <div style={{
              background: "#fff", borderRadius: 10, padding: 32, minWidth: 350, maxWidth: 500, width: "100%",
              boxShadow: "0 4px 32px #0002", display: "flex", flexDirection: "column", gap: 16
            }}>
              <h3 style={{ margin: 0 }}>{editingExpId ? "Editar experiencia" : "Agregar experiencia"}</h3>
              <input
                className="input"
                placeholder="Título"
                value={modalExp.title}
                onChange={e => setModalExp({ ...modalExp, title: e.target.value })}
              />
              <textarea
                className="input"
                placeholder="Descripción"
                value={modalExp.description}
                onChange={e => setModalExp({ ...modalExp, description: e.target.value })}
                rows={4}
                style={{ resize: "vertical" }}
              />
              <input
                className="input"
                placeholder="URL de imagen"
                value={modalExp.image}
                onChange={e => setModalExp({ ...modalExp, image: e.target.value })}
              />
              {/* Skills como objetos */}
              <div style={{ marginBottom: 12 }}>
                <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                  <input
                    className="input"
                    placeholder="Nombre"
                    value={techDraft.name}
                    onChange={e => setTechDraft({ ...techDraft, name: e.target.value })}
                    style={{ flex: 1 }}
                  />
                  <input
                    className="input"
                    placeholder="Clase de icono (ej: devicon-react-original colored)"
                    value={techDraft.icon}
                    onChange={e => setTechDraft({ ...techDraft, icon: e.target.value })}
                    style={{ flex: 2 }}
                  />
                  <button className="buttonSmall" type="button" onClick={handleAddTech}>
                    +
                  </button>
                </div>
                {/* <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                  {Array.isArray(modalExp.skills) && modalExp.skills.map((tech, idx) => (
                    <span key={idx} style={{
                      display: "inline-flex", alignItems: "center", background: "#eee", borderRadius: 6, padding: "4px 10px"
                    }}>
                      <span>{tech.name}</span>
                      <span>
                        <i className={tech.icon} style={{ fontSize: 18 }}></i>
                      </span>
                      <button
                        type="button"
                        style={{ marginLeft: 6, background: "none", border: "none", color: "#c00", cursor: "pointer" }}
                        onClick={() => handleDeleteTech(idx)}
                      >×</button>
                    </span>
                  ))}
                </div> */}
                <ul style={{ margin: 0, padding: 0, listStyle: "none" }}>
                {(modalExp.skills || []).map((tech, i) => (
                  <li key={i} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
                    <span>{tech.name}</span>
                    <span>
                      <i className={tech.icon} style={{ fontSize: 18 }}></i>
                    </span>
                    <button
                      className="buttonDanger"
                      style={{ padding: "0 8px", fontSize: 14 }}
                      type="button"
                      onClick={() => handleDeleteTech(i)}
                    >X</button>
                  </li>
                ))}
              </ul>
              </div>
              <div style={{ display: "flex", gap: 12, justifyContent: "flex-end" }}>
                <button className="button" onClick={saveExpModal}>
                  {editingExpId ? "Guardar cambios" : "Agregar"}
                </button>
                <button className="buttonDanger" onClick={() => setShowExpModal(false)}>
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}